import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, PlayCircle, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { SectionTitle } from "@/components/Section";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    api.get("/courses").then(({ data }) => setCourses(data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-8">
      <SectionTitle sub="Structured, mentor-led programmes to sharpen your highest-impact papers" testId="courses-page-title">
        Courses by Arpita
      </SectionTitle>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {courses.map((c) => (
          <div key={c.id} className="gov-card flex flex-col overflow-hidden" data-testid={`course-${c.slug}`}>
            <div className="relative">
              <img src={c.image} alt={c.title} className="h-48 w-full object-cover" />
              <span className="absolute left-3 top-3 rounded-sm bg-[#D97706] px-2 py-0.5 text-[11px] font-bold uppercase text-white">Paid Course</span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-serif text-xl font-bold text-[#0B2545]">{c.title}</h3>
              <p className="mt-1 text-sm text-gray-600">{c.subtitle}</p>
              <div className="mt-3 flex flex-wrap gap-4 text-xs text-gray-500">
                <span className="flex items-center gap-1"><Clock size={13} /> {c.duration}</span>
                <span className="flex items-center gap-1"><PlayCircle size={13} /> {c.lessons} lessons</span>
              </div>
              <ul className="mt-4 space-y-1.5">
                {c.features.slice(0, 3).map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-gray-700">
                    <CheckCircle2 size={15} className="mt-0.5 shrink-0 text-[#16A34A]" /> {f}
                  </li>
                ))}
              </ul>
              <div className="mt-auto flex items-center justify-between pt-5">
                <div className="flex items-center gap-2">
                  <span className="font-serif text-2xl font-bold text-[#0B2545]">₹{c.price}</span>
                  {c.original_price && <span className="text-sm text-gray-400 line-through">₹{c.original_price}</span>}
                </div>
                <Link to={`/courses/${c.slug}`} className="inline-flex items-center gap-1.5 rounded-sm bg-[#1F3A68] px-4 py-2 text-sm font-semibold text-white hover:bg-[#0B2545]" data-testid={`course-view-${c.slug}`}>
                  View Details <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
